<template>
  <div class="upload-card">

    <div class="upload-header">

      <h3>{{ title }}</h3>

      <p>
      
      {{ description }}
      
      </p>

    </div>

    <div class="upload-content">

      <input
        ref="fileInput"
        type="file"
        accept=".xlsx,.xls"
        style="display:none"
        @change="handleFile"
      >

      <button
        class="upload-btn"
        @click="chooseFile"
      >
        选择Excel文件
      </button>

      <div
        v-if="fileName"
        class="file-name"
      >
        当前文件：{{ fileName }}
      </div>

      <div class="tips">
        支持格式：xlsx、xls
      </div>

    </div>

  </div>
</template>

<script>

import * as XLSX from 'xlsx'

export default {

  data() {

    return {

      fileName: ''

    }

  },

  methods: {

    chooseFile() {

      this.$refs.fileInput.click()

    },

    handleFile(event) {

      const file = event.target.files[0]

      if (!file) {

        return

      }

      this.fileName = file.name

      const reader = new FileReader()

      reader.onload = e => {

        try {

          const workbook = XLSX.read(
            e.target.result,
            {
              type: 'binary'
            }
          )

          const sheet =
            workbook.Sheets[
              workbook.SheetNames[0]
            ]

          const data =
            XLSX.utils.sheet_to_json(
              sheet
            )

          if (data.length === 0) {

            alert('Excel中没有数据')

            return

          }

          const firstRow = data[0]

          if (
            !('公司名称' in firstRow) ||
            !('店面名称' in firstRow) ||
            !('完成业绩' in firstRow)
          ) {

            alert(
              '模板错误，请上传标准业绩明细表'
            )

            return

          }

          this.$emit(
            'success',
            data
          )

        }
        catch (error) {

          console.error(error)

          alert(
            'Excel解析失败'
          )

        }

      }

      reader.readAsBinaryString(
        file
      )

    }

  }

}
</script>

<style scoped>

.upload-card {

  background: #fff;

  border: 1px solid #e5e5e5;

  border-radius: 10px;

  padding: 25px;

  box-shadow:
    0 2px 8px rgba(0,0,0,.05);

}

.upload-header h3 {

  margin: 0;

  color: #333;

}

.upload-header p {

  margin-top: 10px;

  color: #666;

}

.upload-content {

  margin-top: 20px;

}

.upload-btn {

  background: #c00000;

  color: #fff;

  border: none;

  border-radius: 6px;

  padding: 10px 20px;

  cursor: pointer;

  font-size: 14px;

}

.upload-btn:hover {

  background: #a50000;

}

.file-name {

  margin-top: 15px;

  color: #333;

}

.tips {

  margin-top: 10px;

  color: #999;

  font-size: 12px;

}

</style>